document.addEventListener('DOMContentLoaded', function() {
  // Price Range Slider
  const DEFAULT_MIN = 0;
  const DEFAULT_MAX = 69999;
  
  const minPriceInput = document.getElementById('min-price');
  const maxPriceInput = document.getElementById('max-price');
  const visualMinPrice = document.getElementById('visual-min-price');
  const visualMaxPrice = document.getElementById('visual-max-price');
  const displayMinPrice = document.getElementById('display-min-price');
  const displayMaxPrice = document.getElementById('display-max-price');
  const priceSliderTrack = document.querySelector('.price-slider-track');
  const priceSliderRange = document.querySelector('.price-slider-range');
  const minHandle = document.querySelector('.min-handle');
  const maxHandle = document.querySelector('.max-handle');
  const clearFiltersBtn = document.getElementById('clear-filters');
  const inStockCheckbox = document.getElementById('in-stock');
  const outOfStockCheckbox = document.getElementById('out-of-stock');
  const clearAllBtn = document.querySelector('.active-filters__clear');
  const viewControls = document.querySelector('.collection-view-controls');
  const productGrid = document.getElementById('product-grid');
  
  let currentMin = DEFAULT_MIN;
  let currentMax = DEFAULT_MAX;
  let isDraggingMin = false;
  let isDraggingMax = false;
  
  // Make filter sections collapsible
  const filterSections = document.querySelectorAll('.filter-section');

  filterSections.forEach(section => {
    const title = section.querySelector('.filter-title');
    const content = section.querySelector('.filter-options, .price-range-container, .featured-products-sidebar');

    if (title && content) {
      // Wrap content in a div for smooth animation if not already wrapped
      let contentWrapper = section.querySelector('.filter-content');
      if (!contentWrapper) {
        contentWrapper = document.createElement('div');
        contentWrapper.className = 'filter-content';
        contentWrapper.appendChild(content);
        section.appendChild(contentWrapper);
      }

      // Set initial state (open by default)
      section.classList.remove('collapsed');
      title.setAttribute('aria-expanded', 'true');
      updateToggleIcon(title, false);

      // Click event on title
      title.addEventListener('click', () => {
        const isCollapsed = section.classList.toggle('collapsed');
        title.setAttribute('aria-expanded', !isCollapsed);
        updateToggleIcon(title, isCollapsed);
      });
    }
  });

  // Helper: update icon
  function updateToggleIcon(title, isCollapsed) {
    const icon = title.querySelector('.toggle-icon');
    if (icon) {
      icon.textContent = isCollapsed ? '+' : '−';
    }
  }

  // Fix for price input fields
  function handlePriceInputFocus(e) {
    // When focusing, if value is default, clear it
    if (parseInt(e.target.value) === (e.target.id === 'min-price' ? DEFAULT_MIN : DEFAULT_MAX)) {
      e.target.value = '';
    }
  }
  
  function handlePriceInputBlur(e) {
    // When blurring, if empty, set to default
    if (e.target.value === '') {
      e.target.value = e.target.id === 'min-price' ? DEFAULT_MIN : DEFAULT_MAX;
      updateFromInputs();
    }
  }
  
  if (minPriceInput) {
    minPriceInput.addEventListener('focus', handlePriceInputFocus);
    minPriceInput.addEventListener('blur', handlePriceInputBlur);
  }
  
  if (maxPriceInput) {
    maxPriceInput.addEventListener('focus', handlePriceInputFocus);
    maxPriceInput.addEventListener('blur', handlePriceInputBlur);
  }

  if (viewControls && productGrid) {
    // Handle click events
    viewControls.addEventListener('click', function(e) {
      const viewOption = e.target.closest('.view-option');
      if (!viewOption) return;
      
      handleViewChange(viewOption);
    });
    
    // Handle keyboard events
    viewControls.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        const viewOption = e.target.closest('.view-option');
        if (!viewOption) return;
        
        e.preventDefault();
        handleViewChange(viewOption);
      }
    });

    function updateViewForScreenSize() {
      const viewControls = document.querySelector('.collection-view-controls');
      if (!viewControls) return;
    
      const currentActive = viewControls.querySelector('.view-option.active');
      const isListView = currentActive && currentActive.dataset.view === 'list';
      const isMobileScreen = window.innerWidth <= 1025;
    
      // Don't change if list view is active
      if (isListView) return;
    
      if (isMobileScreen) {
        // Switch to mobile grid (2 columns) on mobile
        const mobileOption = viewControls.querySelector('.view-option[data-view="mobile-grid"]');
        if (mobileOption && !mobileOption.classList.contains('active')) {
          mobileOption.click();
        }
      } else {
        // On larger screens, restore the saved view if available
        const savedView = localStorage.getItem('collectionView');
        if (savedView && savedView !== 'mobile-grid') {
          const savedOption = viewControls.querySelector(`.view-option[data-view="${savedView}"]`);
          if (savedOption && !savedOption.classList.contains('active')) {
            savedOption.click();
          }
        }
      }
    }
    
    function handleViewChange(selectedOption) {
      // Update active state
      document.querySelectorAll('.view-option').forEach(option => {
        option.classList.remove('active');
      });
      selectedOption.classList.add('active');
      
      // Get the view type
      const viewType = selectedOption.dataset.view;
      const grid = productGrid.querySelector('.grid');
      
      if (grid) {
        // Remove all view classes
        grid.classList.remove('grid-2', 'grid-3', 'grid-4', 'mobile-grid', 'list-view');
        
        // Add the selected view class
        if (viewType === 'list') {
          grid.classList.add('list-view');
        } else {
          let cols;
          if (viewType === 'mobile-grid') {
            cols = '2'; // Mobile grid is always 2 columns
          } else {
            cols = viewType.split('-')[1];
          }
          grid.classList.add(`grid-${cols}`);
          
          // Update grid columns class
          const currentColClass = Array.from(grid.classList).find(c => c.startsWith('grid--') && c.endsWith('-col-desktop'));
          if (currentColClass) {
            grid.classList.remove(currentColClass);
          }
          grid.classList.add(`grid--${cols}-col-desktop`);
        }
      }
      
      // Save preference (except for mobile-grid which is default)
      if (viewType !== 'mobile-grid') {
        localStorage.setItem('collectionView', viewType);
      }
    }

    // Add resize event listener
    window.addEventListener('resize', debounce(function() {
      updateViewForScreenSize();
    }, 200));
    
    // Initialize the view
    document.addEventListener('DOMContentLoaded', function() {
      // Load saved view or set default based on screen size
      const savedView = localStorage.getItem('collectionView');
      const viewControls = document.querySelector('.collection-view-controls');
      
      if (viewControls) {
        if (window.innerWidth <= 1025) {
          // On mobile, default to 2-column grid unless list view was selected
          if (savedView === 'list') {
            const listOption = viewControls.querySelector('.view-option[data-view="list"]');
            if (listOption) listOption.click();
          } else {
            const mobileOption = viewControls.querySelector('.view-option[data-view="mobile-grid"]');
            if (mobileOption) mobileOption.click();
          }
        } else {
          // On desktop, default to 3-column grid unless another view was saved
          if (savedView && savedView !== 'mobile-grid') {
            const savedOption = viewControls.querySelector(`.view-option[data-view="${savedView}"]`);
            if (savedOption) savedOption.click();
          } else {
            const threeColOption = viewControls.querySelector('.view-option[data-view="grid-3"]');
            if (threeColOption) threeColOption.click();
          }
        }
      }
    });

    function debounce(func, wait) {
      let timeout;
      return function() {
        const context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
          func.apply(context, args);
        }, wait);
      };
    }
    
    // Load saved view preference
    const savedView = localStorage.getItem('collectionView');
    if (savedView) {
      const savedOption = viewControls.querySelector(`.view-option[data-view="${savedView}"]`);
      if (savedOption) {
        savedOption.click();
      }
    } else if (window.innerWidth <= 749) {
      // Default to mobile grid on small screens
      const mobileOption = viewControls.querySelector('.view-option[data-view="mobile-grid"]');
      if (mobileOption) {
        mobileOption.click();
      }
    }
  }
  
  function formatPrice(price) {
    return parseFloat(price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  
  function updatePriceDisplays() {
    visualMinPrice.textContent = formatPrice(currentMin);
    visualMaxPrice.textContent = formatPrice(currentMax);
    displayMinPrice.textContent = formatPrice(currentMin);
    displayMaxPrice.textContent = formatPrice(currentMax);
    minPriceInput.value = currentMin;
    maxPriceInput.value = currentMax;
  }
  
  function updateSliderPosition() {
    const minPos = (currentMin / DEFAULT_MAX) * 100;
    const maxPos = (currentMax / DEFAULT_MAX) * 100;
    
    priceSliderRange.style.left = `${minPos}%`;
    priceSliderRange.style.right = `${100 - maxPos}%`;
    
    minHandle.style.left = `${minPos}%`;
    maxHandle.style.left = `${maxPos}%`;
  }
  
  function getPriceFromPosition(pos) {
    return Math.round((pos / priceSliderTrack.offsetWidth) * DEFAULT_MAX);
  }
  
  function handleDragStart(e) {
    e.preventDefault();
    const handle = e.target;
    
    if (handle.classList.contains('min-handle')) {
      isDraggingMin = true;
    } else if (handle.classList.contains('max-handle')) {
      isDraggingMax = true;
    }
    
    document.addEventListener('mousemove', handleDrag);
    document.addEventListener('mouseup', handleDragEnd);
    document.addEventListener('touchmove', handleDrag);
    document.addEventListener('touchend', handleDragEnd);
  }
  
  function handleDrag(e) {
    if (!isDraggingMin && !isDraggingMax) return;
    
    const rect = priceSliderTrack.getBoundingClientRect();
    let pos = (e.clientX || e.touches[0].clientX) - rect.left;
    pos = Math.max(0, Math.min(rect.width, pos));
    
    const newPrice = getPriceFromPosition(pos);
    
    if (isDraggingMin) {
      currentMin = Math.min(newPrice, currentMax);
      updatePriceDisplays();
      updateSliderPosition();
    } else if (isDraggingMax) {
      currentMax = Math.max(newPrice, currentMin);
      updatePriceDisplays();
      updateSliderPosition();
    }
  }
  
  function handleDragEnd() {
    isDraggingMin = false;
    isDraggingMax = false;
    filterProducts();
    updateActiveFiltersDisplay();
    
    document.removeEventListener('mousemove', handleDrag);
    document.removeEventListener('mouseup', handleDragEnd);
    document.removeEventListener('touchmove', handleDrag);
    document.removeEventListener('touchend', handleDragEnd);
  }
  
  function updateFromInputs() {
    // Only update if inputs have values
    if (minPriceInput.value !== '') {
      currentMin = parseInt(minPriceInput.value) || DEFAULT_MIN;
    }
    if (maxPriceInput.value !== '') {
      currentMax = parseInt(maxPriceInput.value) || DEFAULT_MAX;
    }
    
    if (currentMin > currentMax) {
      [currentMin, currentMax] = [currentMax, currentMin];
      minPriceInput.value = currentMin;
      maxPriceInput.value = currentMax;
    }
    
    currentMin = Math.max(DEFAULT_MIN, Math.min(DEFAULT_MAX, currentMin));
    currentMax = Math.max(DEFAULT_MIN, Math.min(DEFAULT_MAX, currentMax));
    
    updatePriceDisplays();
    updateSliderPosition();
    filterProducts();
    updateActiveFiltersDisplay();
  }
  
  // Active Filters Display
  function updateActiveFiltersDisplay() {
    const urlParams = new URLSearchParams(window.location.search);
    const activeFiltersContainer = document.querySelector('.active-filters');
    const clearAllBtn = document.querySelector('.active-filters__clear');
    
    if (!activeFiltersContainer) return;
    
    // Clear existing filters
    activeFiltersContainer.innerHTML = '';
    
    // Price filter
    const minPrice = urlParams.get('filter.v.price.gte');
    const maxPrice = urlParams.get('filter.v.price.lte');
    if (minPrice || maxPrice) {
      const displayMin = minPrice ? formatPrice(minPrice) : '0.00';
      const displayMax = maxPrice ? formatPrice(maxPrice) : formatPrice(DEFAULT_MAX);
      
      const priceUrl = new URL(window.location);
      priceUrl.searchParams.delete('filter.v.price.gte');
      priceUrl.searchParams.delete('filter.v.price.lte');
      
      const priceFilter = document.createElement('a');
      priceFilter.className = 'active-filters__remove-filter';
      priceFilter.href = priceUrl.toString();
      priceFilter.innerHTML = `Price: Rs. ${displayMin} - Rs. ${displayMax} <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 3L3 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M3 3L9 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>`;
      
      activeFiltersContainer.appendChild(priceFilter);
    }
    
    // Availability filter
    const availabilityParam = urlParams.get('filter.v.availability');
    if (availabilityParam) {
      const availabilityUrl = new URL(window.location);
      availabilityUrl.searchParams.delete('filter.v.availability');
      
      const availabilityFilter = document.createElement('a');
      availabilityFilter.className = 'active-filters__remove-filter';
      availabilityFilter.href = availabilityUrl.toString();
      availabilityFilter.innerHTML = `${availabilityParam === '1' ? 'In stock' : 'Out of stock'} <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 3L3 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M3 3L9 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>`;
      
      activeFiltersContainer.appendChild(availabilityFilter);
    }
    
    // Show/hide clear all button
    if (clearAllBtn) {
      if (activeFiltersContainer.children.length > 0) {
        clearAllBtn.style.display = 'inline-block';
      } else {
        clearAllBtn.style.display = 'none';
      }
    }
  }

  function filterProducts() {
    const inStockChecked = inStockCheckbox.checked;
    const outOfStockChecked = outOfStockCheckbox.checked;
    
    let url = new URL(window.location.pathname, window.location.origin);
    
    if (currentMin > DEFAULT_MIN) {
      url.searchParams.set('filter.v.price.gte', currentMin);
    }
    if (currentMax < DEFAULT_MAX) {
      url.searchParams.set('filter.v.price.lte', currentMax);
    }
    
    if (inStockChecked && !outOfStockChecked) {
      url.searchParams.set('filter.v.availability', '1');
    } else if (!inStockChecked && outOfStockChecked) {
      url.searchParams.set('filter.v.availability', '0');
    }
    
    url.searchParams.delete('page');
    
    const loadingHTML = '<div class="loading-spinner">Loading...</div>';
    document.getElementById('product-grid').insertAdjacentHTML('afterbegin', loadingHTML);
    
    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newProductGrid = doc.getElementById('product-grid');
        
        if (newProductGrid) {
          // Update product count
          const newProductCount = doc.querySelector('.product-count');
          if (newProductCount) {
            const currentProductCount = document.querySelector('.product-count');
            if (currentProductCount) {
              currentProductCount.innerHTML = newProductCount.innerHTML;
            }
          }
          
          // Replace content
          document.getElementById('product-grid').innerHTML = newProductGrid.innerHTML;
        }
        
        window.history.pushState({}, '', url.toString());
        updateActiveFiltersDisplay();
      })
      .catch(error => console.error('Error:', error))
      .finally(() => {
        const spinner = document.querySelector('.loading-spinner');
        if (spinner) spinner.remove();
      });
  }
  
  function clearAllFilters() {
    currentMin = DEFAULT_MIN;
    currentMax = DEFAULT_MAX;
    minPriceInput.value = DEFAULT_MIN;
    maxPriceInput.value = DEFAULT_MAX;
    
    inStockCheckbox.checked = false;
    outOfStockCheckbox.checked = false;
    
    updatePriceDisplays();
    updateSliderPosition();
    
    window.location.href = window.location.pathname;
  }
  
  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        func.apply(context, args);
      }, wait);
    };
  }
  
  // Initialize price slider from URL
  const urlParams = new URLSearchParams(window.location.search);
  const minPriceParam = urlParams.get('filter.v.price.gte');
  const maxPriceParam = urlParams.get('filter.v.price.lte');
  const availabilityParam = urlParams.get('filter.v.availability');
  
  if (minPriceParam) {
    currentMin = parseInt(minPriceParam);
    minPriceInput.value = currentMin;
  }
  
  if (maxPriceParam) {
    currentMax = parseInt(maxPriceParam);
    maxPriceInput.value = currentMax;
  }
  
  if (availabilityParam === '1') {
    inStockCheckbox.checked = true;
  } else if (availabilityParam === '0') {
    outOfStockCheckbox.checked = true;
  }
  
  updatePriceDisplays();
  updateSliderPosition();
  updateActiveFiltersDisplay();
  
  // Event listeners
  minHandle.addEventListener('mousedown', handleDragStart);
  minHandle.addEventListener('touchstart', handleDragStart);
  maxHandle.addEventListener('mousedown', handleDragStart);
  maxHandle.addEventListener('touchstart', handleDragStart);
  
  minPriceInput.addEventListener('input', debounce(function() {
    updateFromInputs();
  }, 500));
  
  maxPriceInput.addEventListener('input', debounce(function() {
    updateFromInputs();
  }, 500));
  
  inStockCheckbox.addEventListener('change', function() {
    if (this.checked) {
      outOfStockCheckbox.checked = false;
    }
    filterProducts();
  });
  
  outOfStockCheckbox.addEventListener('change', function() {
    if (this.checked) {
      inStockCheckbox.checked = false;
    }
    filterProducts();
  });
  
  clearFiltersBtn.addEventListener('click', function(e) {
    e.preventDefault();
    clearAllFilters();
  });
  
  if (clearAllBtn) {
    clearAllBtn.addEventListener('click', function(e) {
      e.preventDefault();
      clearAllFilters();
    });
  }

  // Mobile filters drawer functionality
  const mobileFiltersBtn = document.getElementById('mobile-filters-btn');
  const filtersDrawer = document.querySelector('.mobile-filters-drawer');
  const closeFiltersBtn = document.querySelector('.close-filters-drawer');
  const filtersOverlay = document.createElement('div');
  filtersOverlay.className = 'filters-overlay';
  document.body.appendChild(filtersOverlay);
  
  // Toggle filters drawer
  function toggleFiltersDrawer() {
    filtersDrawer.classList.toggle('active');
    filtersOverlay.classList.toggle('active');
    document.body.classList.toggle('no-scroll');
  }
  
  // Open filters drawer
  if (mobileFiltersBtn) {
    mobileFiltersBtn.addEventListener('click', toggleFiltersDrawer);
  }
  
  // Close filters drawer
  if (closeFiltersBtn) {
    closeFiltersBtn.addEventListener('click', toggleFiltersDrawer);
  }
  
  // Close when clicking overlay
  filtersOverlay.addEventListener('click', toggleFiltersDrawer);
  
  // Close when clicking "Apply Filters"
  const applyFiltersBtn = document.querySelector('.apply-filters-btn');
  if (applyFiltersBtn) {
    applyFiltersBtn.addEventListener('click', toggleFiltersDrawer);
  }
  
  // Make mobile filter sections collapsible
  const mobileFilterSections = document.querySelectorAll('.mobile-filters-drawer .filter-section');
  mobileFilterSections.forEach(section => {
    const title = section.querySelector('.filter-title');
    const content = section.querySelector('.filter-content');
    
    if (title && content) {
      title.addEventListener('click', () => {
        section.classList.toggle('active');
      });
    }
  });

  // Sort dropdown functionality
  const sortDropdown = document.querySelector('.select-custom');
  if (sortDropdown) {
    const sortToggle = sortDropdown.querySelector('.select-selected');
    const sortOptions = sortDropdown.querySelectorAll('.select-custom__content a');
    const currentSortLabel = sortDropdown.querySelector('.subheading_weight');
    const closeIcon = sortDropdown.querySelector('.mobile-close-btn');
    const overlay = sortDropdown.querySelector('.mobile-sort-overlay');

    // Toggle dropdown
    sortToggle.addEventListener('click', function(e) {
      e.preventDefault();
      toggleDropdown();
    });

    // Close when clicking close button
    closeIcon.addEventListener('click', function(e) {
      e.stopPropagation();
      closeDropdown();
    });

    // Close when clicking overlay
    overlay.addEventListener('click', closeDropdown);

    // Handle option selection
    sortOptions.forEach(function(option) {
      option.addEventListener('click', function(e) {
        e.preventDefault();
        const value = this.dataset.value;
        
        // Update UI
        sortOptions.forEach(function(opt) {
          opt.classList.remove('active');
        });
        this.classList.add('active');
        currentSortLabel.textContent = this.textContent.trim();
        
        // Update URL
        const url = new URL(window.location);
        url.searchParams.set('sort_by', value);
        window.location.href = url.toString();
      });
    });

    // Set current sort option from URL
    const urlParams = new URLSearchParams(window.location.search);
    const sortBy = urlParams.get('sort_by') || 'manual';
    
    sortOptions.forEach(function(option) {
      if (option.dataset.value === sortBy) {
        option.classList.add('active');
        currentSortLabel.textContent = option.textContent.trim();
      }
    });
    
    function toggleDropdown() {
      sortDropdown.classList.toggle('active');
      document.body.classList.toggle('mobile-sort-open');
    }
    
    function closeDropdown() {
      sortDropdown.classList.remove('active');
      document.body.classList.remove('mobile-sort-open');
    }
    
    // Close when clicking outside on desktop
    document.addEventListener('click', function(e) {
      if (!sortDropdown.contains(e.target)) {
        closeDropdown();
      }
    });
    
    // Handle window resize
    window.addEventListener('resize', function() {
      if (window.innerWidth > 1024) {
        closeDropdown();
      }
    });
  }
});